import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { FormGroup, H2, H4, HTMLSelect, Icon, Toaster, Button } from '@blueprintjs/core';
import { Paper } from '@material-ui/core';
// import { PUBLIC_URL, ANALYTICS_URL } from '../../../constants';

import DetailByCorpus from './DetailByCorpus';
import {estimatedClass} from './common'
import './Stat.css';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME, FRONT_USER_ROLE_COOKIE_NAME } from '../../../auth/constants.js';

class StatGlobal extends React.PureComponent {

  state = {
    detailStats: 'specByCorpus',  // specByCorpus, freqByCorpus, dispByCorpus, freqByReal
  }

  refHandlers = {
    toaster: (ref) => this.toaster = ref,
  };
  
  showIncompleteResultWarningToast = () => {

    this.toaster.show({
      message: this.props.t('thisValuesAreEstimated'),
      intent: 'warning',
      icon: 'warning-sign',
    });
  }


  onDetailChange = (e) => {
    e.preventDefault();
    this.setState({ detailStats: e.target.value });
  }

  render() {
    const { corpusStats, t, estimatedResults } = this.props;
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    const userPlus = (Cookies.get(FRONT_USER_ROLE_COOKIE_NAME)==='user+') ? true: false ;

    let parsedClass="";
    if (estimatedResults) {
      parsedClass="warn";
    } 

    return(
    <>
      <Paper className="margin-bottom-1-rem padding-1-rem">
        <div className="flex">
          <div className="flex-one-third">
            <H2>{t('searchSpace')}</H2>
            <ul>
              <li>{t('tokenNumberColon')} { Intl.NumberFormat(langFormat).format(corpusStats.size)}</li>
              <li>{t('sentencesToParseColon')} {Intl.NumberFormat(langFormat).format(corpusStats.nbSents2Parse)}</li>
              <li className={parsedClass}>{t('sentencesParsedColon')} {Intl.NumberFormat(langFormat).format(corpusStats.nbParsedSents)}
                &nbsp;
                {(estimatedResults) && <Icon icon="warning-sign" onMouseEnter={this.showIncompleteResultWarningToast} />}
              </li>
            </ul>
            {(estimatedResults) && 
              <div>
                <p className={parsedClass}>{t('onlyASampleOfTheCorpusHasBeenSearched')}</p>
                <Button onClick={ () => { this.props.performSearch({useCompleteSearch:true}) }}>{t('runAgain')}</Button>
              </div>
            }
            {(userPlus) && 
              <div>
                <Button onClick={ this.props.runMLM }>{t('runMLM')}</Button>
              </div>
            }
          </div>
          <div className="flex-two-third">
            <H2>{t('query')}</H2>
            <div dangerouslySetInnerHTML={{__html:this.props.querySvg}}></div>
          </div>
        </div>
        <Toaster ref={this.refHandlers.toaster} />
      </Paper>

      <Paper className="margin-bottom-1-5-rem padding-1-rem">
        <H2>{t('searchResults')}</H2>

        <div className="margin-bottom-1-rem">
          <H4><u>{t('syntheticStats')}</u></H4>
          <ul>
              { this.props.missingSubCorpora.length >0 && 
                <li>{t('missingSubCorpora')} {this.props.missingSubCorpora.join(", ")}</li>
              }

             <li>
                <span className={estimatedClass(corpusStats.freq,estimatedResults)}>
                  {t('frequencyColon')} { Intl.NumberFormat(langFormat).format(corpusStats.freq)}
                </span>
             </li>
             <li>{t('dispColon')} {Intl.NumberFormat(langFormat).format(corpusStats.disp)} {"("+this.props.dispCriterion+")"}</li>
             { corpusStats.disps && 
                Object.keys(corpusStats.disps).map( dispCriterion => 
                  <li key={dispCriterion}>{dispCriterion}: {Intl.NumberFormat(langFormat).format(corpusStats.disps[dispCriterion])}</li>
                )
             }
          </ul>
          
        </div>

        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('detailedStats')}</u></H4>
          <FormGroup label={t('type')} labelFor='statsDetails' inline={true}>
            <HTMLSelect id='statsDetails' name='statsDetails' onChange={this.onDetailChange}>
              <option value='specByCorpus'>{t('specByCorpus')}</option>
              <option value='freqByCorpus'>{t('freqByCorpus')}</option>
              <option value='dispByCorpus'>{t('dispByCorpus')}</option>
              {/* <option value='freqByReal'>{t('freqByReal')}</option>
              <option value='dispByReal'>{t('dispByReal')}</option> */}
            </HTMLSelect>
          </FormGroup>
        </div>

{/*         {(this.state.detailStats === 'freqByReal' || this.state.detailStats === 'dispByReal') &&
          <DetailByReal
            corpusStats={corpusStats}
            type={this.state.detailStats}
            incompleteExtraction={estimatedResults}
            realSpec={this.props.realSpec}
          />
        } */}


        <DetailByCorpus
          corpusStats={corpusStats.byCorpus}
          type={this.state.detailStats}
          incompleteExtraction={estimatedResults}
          dispCriterion={this.props.dispCriterion}
          csvDelimiter={this.props.csvDelimiter}
        />
      </Paper>
    </>
    );
  }

}

StatGlobal.propTypes = {
  corpusStats: PropTypes.object,
  //realSpec: PropTypes.object,
  query: PropTypes.string,
  querySvg: PropTypes.string,
  estimatedResults: PropTypes.bool,
  pasteQuery: PropTypes.func,
  performSearch: PropTypes.func,
  runMLM: PropTypes.func,
  dispCriterion: PropTypes.string,
  csvDelimiter: PropTypes.string,
  missingSubcorpora:  PropTypes.array,
};

export default withTranslation()(StatGlobal);
